import React from 'react'

export default function Body(props) {
  return (
    <div>
      <br></br>
      <br></br>
      <h1 className="font30 extraBold">
        {props.title}
      </h1>
      <br></br>
      <p className="font16 regular">
        {props.desc}
      </p>
      <br></br>
      <p className="font16 regular">
        {props.desc1}
      </p>
      <br></br>
      <p className="font16 regular">
        {props.desc2}
      </p>
    </div>
  )
}
